import { HttpAdapter, AnyAdapter } from './adapter';
import { Preset, PresetSet } from '../models/preset';
import { HttpResponse } from 'vue-resource/types/vue_resource';

class PresetAdapter implements HttpAdapter<Preset>, AnyAdapter<Preset> {

    public adapt(input: HttpResponse): Preset {
        const data = input.data;
        return this.adaptAny(data);
    }

    public adpatArray(input: HttpResponse): PresetSet {
        const data = input.data;
        var inner = this.adaptAnyArray(data.inner);
        var complete = this.adaptAnyArray(data.complete);

        return {
            inner: inner,
            complete: complete
        };
    }

    public adaptAnyArray(input: any[]): Preset[] {
        return input.map<Preset>(x => this.adaptAny(x));
    }

    public adaptAny(input: any): Preset {
        const result = {
            presetId: input.presetId,
            projectId: input.projectId,
            avatar: input.avatar,
            name: input.name,
            projectJson: input.projectJson
        };
        return result;
    }
}

export const presetAdapter = new PresetAdapter();
